
      <div class="jui-pager" [style.height.px]="height"
          *ngIf="this.page.total > 0">
          <div class="jpager-left" [style.line-height.px]="height"
              *ngIf="showInfo" [style.float]="align!=='right'?'left': 'right'">
              {{page.start + 1}} - {{page.end}}条，共{{page.total}}条
          </div>
          <div class="jpager-right" [style.float]="align!=='left'?'right': 'left'">
              <div class="inner jump">
                  <div class="addition-wrap">
                      <label class="desc" *ngIf="showJumpTool">转到:
                          <jui-select [selected]="page.curPage + 1" 
                              (selectedChange)="onPageNoChange($event)"
                              [dataSrc]="page.allPageNos"
                              minWidth="50" [height]="height">
                          </jui-select>页
                      </label>
                      <span *ngIf="showTotalPages">/ 共{{page.totalPage}}页</span>
                  </div>
                  <div class="addition-wrap" *ngIf="showPageTool">
                      <label class="desc">每页:
                          <jui-select [(selected)]="page.pageSize"
                              (selectedChange)="onSizeChange($event)"
                              [dataSrc]="page.pageSizeOpts"
                              minWidth="50" [height]="height">
                          </jui-select>条
                      </label>
                  </div>
              </div>
              <div class="inner page-nos">
                  <ul>
                      <li (click)="goFirstPage()" [ngClass]="page.curPage !== 0 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">«</a>
                      </li>
                      <li (click)="goPrevPage()" [ngClass]="page.curPage !== 0 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">‹</a>
                      </li>
                      <li (click)="selectPage(index)"
                          *ngFor="let index of page.pageNos"
                          [ngClass]="index === page.curPage + 1 ? 'active' : 'clickable' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">{{index}}</a>
                      </li>
                      <li (click)="goNextPage()" [ngClass]="page.curPage !== page.totalPage - 1 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">›</a>
                      </li>
                      <li (click)="goLastPage()" [ngClass]="page.curPage !== page.totalPage - 1 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">»</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
    